import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { C as ContainerColor } from './roche-container.types.js';

const rocheHighlightBoxCss = ":host{display:block;margin-top:3rem;margin-top:0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .box{padding:2.5rem;}:host .box ::slotted(*){margin-top:0}@media (min-width: 64rem){:host .box ::slotted(*){margin-top:0}}:host .box ::slotted(roche-headline){margin-top:0 !important}:host .box--colored{z-index:-100}:host .box--colored-theme-aware{background-color:var(--color-background--default)}:host .box--colored-grey{background-color:#c2bab5}:host .box--colored-neutral{background-color:#fac9b5}";
const RocheHighlightBoxStyle0 = rocheHighlightBoxCss;

const RocheHighlightBox$1 = /*@__PURE__*/ proxyCustomElement(class RocheHighlightBox extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.color = ContainerColor.THEME_AWARE;
    }
    render() {
        this.boxClasses = {
            [`box--colored-${this.color}`]: true,
            box: true,
        };
        return (h("div", { key: '9139d25c64d10d2a414056c2dbc144c7a1b4f29b', class: this.boxClasses }, h("slot", { key: '3f4f4c7bd16fd4f66614592f4d87da1b29eb89ad' })));
    }
    static get style() { return RocheHighlightBoxStyle0; }
}, [1, "roche-highlight-box", {
        "color": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-highlight-box"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-highlight-box":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheHighlightBox$1);
            }
            break;
    } });
}

const RocheHighlightBox = RocheHighlightBox$1;
const defineCustomElement = defineCustomElement$1;

export { RocheHighlightBox, defineCustomElement };

//# sourceMappingURL=roche-highlight-box.js.map